import { render, staticRenderFns } from "./weiaiAll.vue?vue&type=template&id=75c24cb6&scoped=true&"
import script from "./weiaiAll.vue?vue&type=script&lang=js&"
export * from "./weiaiAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c24cb6",
  null
  
)

export default component.exports